module.exports = __webpack_public_path__ + "static/media/exchange-order-serviceablity-1.4c29a49b.png";